export default "__VITE_ASSET__DbWxXIG5__"